import { FC } from 'react'
import { Divider, Spin } from 'antd'
import PerIcon from '../../../components/custom_components/Icon'

interface Props {
  loading: boolean
  expandable?: boolean
  searchTerm?: string
  onClick?: () => void
}

export const SuffixIcon: FC<Props> = ({ loading, searchTerm = '', expandable = false, onClick = undefined }) => {
  return (
    <>
      <Divider type="vertical" />
      {loading ? (
        <Spin size="small" spinning={loading} />
      ) : (
        <div
          onClick={
            searchTerm.length < 3
              ? (e: any) => {
                  e.stopPropagation()
                }
              : onClick
          }
          style={{
            cursor: `${!expandable ? 'auto' : searchTerm.length < 3 ? 'not-allowed' : 'pointer'}`,
            width: '16px',
            height: '16px',
          }}
        >
          <PerIcon name="magnifier_fill" size={16} />
        </div>
      )}
    </>
  )
}
